module.exports = __webpack_public_path__ + "media/images/thumbnails/thumbs_start-c06cb9c58cd8d1a3da7d725055fc1164.jpg";